import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaRemote, useMediaState } from "@vidstack/react";
import BasePlayerButton from "./BasePlayerButton";
const FullscreenButton = () => {
    const remote = useMediaRemote();
    const isFullscreen = useMediaState("fullscreen");
    const icon = isFullscreen ? "minimize" : "maximize";
    const label = isFullscreen ? "Sair da tela cheia" : "Tela cheia";
    return (_jsx(BasePlayerButton, { label: label, iconName: icon, onClick: () => {
            remote.toggleFullscreen();
        } }));
};
FullscreenButton.displayName = "FullscreenButton";
export default FullscreenButton;
